function createLocalTeam(input) {
  const internalId = `${input.title}-${input.subjects.join(",")}-${input.teams.join(",")}`;
  return {
    id: internalId,
    key: internalId,
    createdAt: new Date(),
    modifiedAt: new Date(),
    enabledNotifications: true,
    ...input
  };
}

export { createLocalTeam };
//# sourceMappingURL=util.create-local-team.js.map
